import Avgol from '../../images/clients/Avgol.webp';
import Barkan from '../../images/clients/Barkan.webp';
import Mekorot from '../../images/clients/Mekorot.webp';
import Moog from '../../images/clients/Moog.png';
import Nilit from '../../images/clients/Nilit.png';
import PCB from '../../images/clients/PCB.webp';
import Tempo from '../../images/clients/tempo.webp';
import Campro from '../../images/clients/campro.webp';

// Client logos approved for public use (see PRODUCT.md).
const clients = [
  { name: 'Avgol', nameHe: 'אבגול', logo: Avgol },
  { name: 'Barkan', nameHe: 'ברקן', logo: Barkan },
  { name: 'Mekorot', nameHe: 'מקורות', logo: Mekorot },
  { name: 'Moog', nameHe: 'Moog', logo: Moog },
  { name: 'Nilit', nameHe: 'נילית', logo: Nilit },
  { name: 'PCB Technologies', nameHe: 'PCB Technologies', logo: PCB },
  { name: 'Tempo', nameHe: 'טמפו', logo: Tempo },
  { name: 'CAMPRO', nameHe: 'CAMPRO', logo: Campro },
];

export default clients;
